import { render } from "./InterestTraining.vue?vue&type=template&id=4b66a08a&scoped=true&ts=true"
import script from "./InterestTraining.vue?vue&type=script&lang=ts"
export * from "./InterestTraining.vue?vue&type=script&lang=ts"

import "./InterestTraining.vue?vue&type=style&index=0&id=4b66a08a&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b66a08a"]])

export default __exports__